import { render, staticRenderFns } from "./tech_map.vue?vue&type=template&id=0fbabf14&scoped=true&lang=pug&"
import script from "./tech_map.vue?vue&type=script&lang=js&"
export * from "./tech_map.vue?vue&type=script&lang=js&"
import style0 from "./tech_map.vue?vue&type=style&index=0&id=0fbabf14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbabf14",
  null
  
)

export default component.exports